import createReactComponent from '../createReactComponent';
var AlarmPlus = createReactComponent('AlarmPlus', [['path', {
  d: 'M12 21a8 8 0 100-16 8 8 0 000 16z',
  key: '15b3hp'
}], ['path', {
  d: 'M5 3L2 6',
  key: '1ap563'
}], ['path', {
  d: 'M22 6l-3-3',
  key: '1lid6i'
}], ['path', {
  d: 'M6 19l-2 2',
  key: 'kjsv60'
}], ['path', {
  d: 'M18 19l2 2',
  key: 'iknjy2'
}], ['path', {
  d: 'M12 10v6',
  key: '1bos4e'
}], ['path', {
  d: 'M9 13h6',
  key: '1uhe8q'
}]]);
export default AlarmPlus;